import LoadingArea from "./LoadingArea.js";
import ConfirmationArea from "./ConfirmationArea.js";
import AlertArea from "./AlertArea.js";
import Error from "../utils/Error.js";
import Room from "../Room.js";
import global from "../global.js";

const log = global.log.getLogger("f_mtac.ui.RoomShareArea");
log.setLevel(log.levels.WARN);

let RoomShareArea = function () {
    var {Modal} = window.f_mtac_theme;
    var room_share_area_modal;
    var $room_share_area = document.getElementById("room_share_area");

    const interaction_end = () => {
        log.debug("RoomShareArea.interaction_end");
        room_share_area_modal.hide();
        $("#room_share_area .zone_1").show();
        $("body").off("click.room_share_area.btn", "#room_share_area .btn");
        $("body").off("keydown", "#room_share_area input");
        $("#input_text_area input").off("focus");
    };
    this.sharing_timeout = 30;

    this.interact = function () {
        if (!(global.configuration.profiles[global.configuration.user.level].rights & global.configuration.rights.PROFILE_RIGHTS_WRITE)) {
            $("#room_share_area .zone_1").hide();
        }
        room_share_area_modal = new Modal($room_share_area);
        return new Promise((resolve) => {
            room_share_area_modal.show();
            $("#room_share_area .invalid-feedback").text("");
            $("#room_share_area .invalid-feedback").hide();
            let handlers = {
                create: async () => {
                    room_share_area_modal.hide();
                    let selected_context = global.storage.selected_context;
                    LoadingArea.interact({
                        tip1: global.internationalization.text("collaboration.Sharing-local-crisis-in-progress")
                    }).then(() => {
                        interaction_end();
                    });
                    try {
                        var response;
                        if (global.storage.selected_space.name === global.internationalization.text("global.Without-name")) {
                            response = await global.server.mtac_room_create({org_name: global.configuration.commissioning.organization});
                        } else {
                            response = await global.server.mtac_room_create({room_name: global.storage.selected_space.name, org_name: global.configuration.commissioning.organization});
                        }
                        var room = new Room(`${response.data.space}0${response.data.secret}`);
                        room.desktop_index = selected_context.index;
                        if (global.storage.selected_space.name === global.internationalization.text("global.Without-name")) {
                            await global.server.mtac_room_connect({space: room.space, desktop: room.desktop, secret: room.secret, org_name: global.configuration.commissioning.organization});
                        } else {
                            await global.server.mtac_room_connect({space: room.space, desktop: room.desktop, secret: room.secret, room_name: global.storage.selected_space.name, org_name: global.configuration.commissioning.organization});
                        }
                        await global.storage.share(room);
                        await global.server.subscribe.connect();
                        if (global.server.network.state === "offline") {
                            throw new Error.build.netdown({
                                message: "network is down"
                            });
                        }
                    } catch (error) {
                        switch (error.status) {
                            case Error.status.access:
                                AlertArea.interact({
                                    type: "danger",
                                    tip1: global.internationalization.text("collaboration.Sharing-not-possible-no-access")
                                });
                                break;
                            default:
                                AlertArea.interact({
                                    type: "danger",
                                    tip1: global.internationalization.text("collaboration.Sharing-not-possible-unreachable-server")
                                });
                                break;
                        }
                        await global.server.subscribe.disconnect();
                        await global.storage.unshare();
                        room = null;
                    } finally {
                        if (LoadingArea.interaction !== null) {
                            LoadingArea.interaction.close();
                        }
                        resolve(room);
                    }
                },
                connect: async () => {
                    $("#room_share_area .invalid-feedback").text("");
                    $("#room_share_area .invalid-feedback").hide();
                    let room_id = $("#room_share_area input").val().toLowerCase();
                    var selected_space = global.storage.selected_space;
                    if (selected_space === null) {
                        return;
                    }
                    // Check room_id format then initialize a room object
                    try {
                        var room = new Room(room_id);
                    } catch (error) {
                        log.debug("RoomShareArea.connect:", error);
                        $("#room_share_area .invalid-feedback").text(global.internationalization.text("collaboration.Unknown-pin-code"));
                        $("#room_share_area .invalid-feedback").show();
                        return;
                    }
                    room.desktop = "0";
                    global.event_bus.subscribe("network.offline", handler_connection_lost);

                    // Check room exists on the server
                    try {
                        log.debug(RoomShareArea.room);
                        await global.server.mtac_room_connect({space: room.space, desktop: room.desktop, secret: room.secret, org_name: global.configuration.commissioning.organization});
                    } catch (error) {
                        log.error(error.status, error);
                        switch (error.status) {
                            case Error.build.netdown:
                                room_share_area_modal.hide();
                                await AlertArea.interact({
                                    type: "danger",
                                    tip1: global.internationalization.text("collaboration.Sharing-not-possible-unreachable-server")
                                });
                                room_share_area_modal.show();
                                break;
                            default:
                                $("#room_share_area .invalid-feedback").text(global.internationalization.text("collaboration.Unknown-pin-code"));
                                $("#room_share_area .invalid-feedback").show();
                                global.event_bus.unsubscribe("network.offline", handler_connection_lost);
                        }
                        return;
                    }

                    room_share_area_modal.hide();

                    // Ask confirmation to overwrite current space
                    if (await selected_space.has_context()) {
                        let confirmation = await ConfirmationArea.interact({
                            title: global.internationalization.text("global.Warning"),
                            tip1: global.internationalization.text("collaboration.Clean-and-replace-local-crisis-by-sharing-crisis")
                        });
                        if (!confirmation) {
                            global.event_bus.unsubscribe("network.offline", handler_connection_lost);
                            resolve(null);
                            return;
                        }
                    }

                    // Download room data & subscribe to modifications
                    LoadingArea.interact({
                        tip1: global.internationalization.text("collaboration.Shared-crisis-recovery-in-progress")
                    }).then(() => {
                        resolve(room);
                    });
                    try {
                        await global.storage.fetch(room); // GET config, object, media, message, users
                        await global.server.subscribe.connect(); // Subscribe to websocket
                    } catch (error) {
                        log.error("RoomShareArea.connect:", error);
                        await AlertArea.interact({
                            type: "danger",
                            tip1: global.internationalization.text("collaboration.Sharing-not-possible-unreachable-server")
                        });
                        return;
                    } finally {
                        if (LoadingArea.interaction !== null) {
                            LoadingArea.interaction.close();
                        }
                        global.event_bus.unsubscribe("network.offline", handler_connection_lost);
                    }
                },
                close: () => {
                    interaction_end();
                    resolve(null);
                }
            };
            $("body").on("click.room_share_area.btn", "#room_share_area .btn", async (event) => {
                let $btn = $(event.currentTarget);
                handlers[$btn.data("method")]();
            });
            $("body").on("keydown", "#room_share_area input", async (event) => {
                // Confirm input when the "Enter" key is pressed .
                if (event.key == "Enter") {
                    event.preventDefault();
                    handlers["connect"]();
                }
            });
            $("#input_text_area input").on("focus", () => {
                $("#room_share_area input").trigger("select");
                $("#room_share_area input")[0].setSelectionRange(0, $("#room_share_area input").val().length);
            });

            $room_share_area.addEventListener("hidden.bs.modal", interaction_end);
        });
    };

    let handler_connection_lost = () => {
        /*AlertArea.interact({
            type: "danger",
            tip1 : "Collaboration impossible (serveur non joignable) !"
        });*/
        log.error("partial content fetch while joining a share");
    };
};
export default new RoomShareArea();
